module.exports = __webpack_public_path__ + "img/handshake.9f459bfc.gif";